import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HowItWorks = ({ onCtaClick }) => {
  const { t } = useTranslation();
  const steps = t('howItWorks.steps', { returnObjects: true });
  
  return (
    <section className="py-24 px-6 bg-burgundy-darker">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20 space-y-4">
          <h2 className="text-sm font-bold text-cream-gold tracking-widest uppercase">
            {t('howItWorks.title')}
          </h2>
          <p className="text-4xl md:text-5xl font-bold text-white max-w-3xl mx-auto leading-tight">
            {t('howItWorks.subtitle')}
          </p>
          <Button 
            onClick={onCtaClick}
            className="mt-6 bg-transparent border-2 border-cream-gold text-cream-gold hover:bg-cream-gold hover:text-burgundy-darkest px-8 py-6 text-base font-semibold rounded-full transition-all duration-300"
          >
            {t('howItWorks.getStarted')}
          </Button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((item, index) => (
            <div 
              key={index} 
              className="relative group"
            >
              <div className="h-full p-8 bg-dark-card/50 backdrop-blur-sm rounded-3xl border-2 border-burgundy hover:border-cream-gold transition-all duration-300 hover:shadow-2xl hover:shadow-cream-gold/20 hover:-translate-y-2">
                <div className="mb-6">
                  <div className="w-14 h-14 bg-gradient-to-br from-cream-gold to-cream-gold-dark text-burgundy-darkest rounded-2xl flex items-center justify-center text-2xl font-bold shadow-lg">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-cream-gold mb-4 leading-tight">
                  {item.title}
                </h3>
                <p className="text-cream-gold-light/80 leading-relaxed">
                  {item.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-8 h-8 text-cream-gold" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
